import { render } from "./ks-header.vue?vue&type=template&id=610b6d24"
import script from "./ks-header.vue?vue&type=script&lang=js"
export * from "./ks-header.vue?vue&type=script&lang=js"

import "./ks-header.vue?vue&type=style&index=0&id=610b6d24&lang=css"
script.render = render

export default script